import has  from 'lodash/has';

export default {
    getSearchPayLoad(state) {
        return state.searchPayload;
    },

    getSearchFilterTags(state) {
        const attrLabel = {
            job_type: 'work type',
            skills: 'skill',
            sector: 'sector',
            contract_type: 'contract type',
            career_level: 'career level',
            perks: 'Perk',
            work_authorisation: 'work authorisation',
            education_level: 'education level',
            languages: 'language',
            job_mode: 'Work mode',
            certifications: 'licence/certification',
        };
        const data = [];
        const searchFilters = state.searchPayload.search_filters;
        let handledSalary = false;
        Object.keys(searchFilters).forEach((key) => {
            if (key === 'job_type' || key === 'skills' || key === 'sector' || key === 'job_mode' || key === 'contract_type' || key === 'career_level' ||
                key === 'perks' || key === 'work_authorisation' || key === 'education_level' || key === 'languages' || key === 'certifications') {
                if (searchFilters[key].length) {
                    searchFilters[key].forEach(function(item) {
                        data.push({ attribute_code: key, id: item.id, value: item.value, label: attrLabel[key] });
                    });
                }
            } else if (key === 'ad_type') {
                if (searchFilters[key].length) {
                    searchFilters[key].forEach(function(item) {
                        data.push({ attribute_code: key, id: item.id, value: item.name, label: 'ad type' });
                    });
                }
            } else if (key === 'industry') {
                if (searchFilters[key].length) {
                    searchFilters[key].forEach(function(item) {
                        data.push({ attribute_code: key, id: item.id, value: item.value, label: 'industry' });
                    });
                }
            } else if (key === 'company_size') {
                if (searchFilters[key].length) {
                    searchFilters[key].forEach(function(item) {
                        data.push({ attribute_code: key, id: item.id, value: item.value, label: 'company size' });
                    });
                }
            } else if (key === 'search_keywords') {
                if (searchFilters.search_keywords) {
                    data.push({ attribute_code: key, id: 0, value: searchFilters.search_keywords, label: 'keyword' });
                }
            } else if ((key === 'pay_max' || key === 'pay_min') && !handledSalary) {
                handledSalary = true;
                if (searchFilters.pay_max && searchFilters.pay_min && searchFilters.pay_max.value && searchFilters.pay_min.value) {
                    data.push({ attribute_code: key, id: searchFilters[key].id, value: 'Salary range', label: 'salary' });
                } else if (searchFilters.pay_max && searchFilters.pay_max.value) {
                    data.push({ attribute_code: key, id: searchFilters[key].id, value: 'Salary range', label: 'salary' });
                } else if (searchFilters.pay_min && searchFilters.pay_min.value) {
                    data.push({ attribute_code: key, id: searchFilters[key].id, value: 'Salary range', label: 'salary' });
                }
            } else if (key === 'posted_within_days') {
                if (searchFilters[key] && searchFilters[key].value) {
                    if (searchFilters[key].days !== 0) {
                        data.push({ attribute_code: key, id: searchFilters[key].id, value: searchFilters[key].value, label: 'posted within' });
                    }
                }
            } else if (key === 'brands') {
                if (searchFilters[key].length) {
                    searchFilters[key].forEach(function(item) {
                        data.push({ attribute_code: key, id: item.id, value: item.name || item.value, label: 'company' });
                    });
                }
            } else if (key === 'classifications') {
                if (searchFilters[key].length) {
                    searchFilters[key].forEach(function(item) {
                        if (item.subclassifications && item.subclassifications.length >= 1) {
                            item.subclassifications.forEach(function(item1) {
                                data.push({ attribute_code: 'subclassifications', id: item1.id, value: item1.value, label: 'subclassification' });
                            });
                        } else if (searchFilters[key].length >= 1) {
                            data.push({ attribute_code: key, id: item.id, value: item.value, label: 'classification' });
                        }
                    });
                }
            } else if (key === 'location' && searchFilters[key]?.id) {
                const location = searchFilters.location || {};
                if (location) {
                    data.push({attribute_code: key, id: location.id, value: location.label, label: 'location'});
                }
            } else if (key === 'applyflow_custom_1') {
                if (searchFilters[key].length) {
                    searchFilters[key].forEach(function(item) {
                        data.push({ attribute_code: key, id: parseInt(item.id), value: item.value, label: 'applyflow_custom_1' });
                    });
                }
            } else if (key === 'applyflow_custom_2') {
                if (searchFilters[key].length) {
                    searchFilters[key].forEach(function(item) {
                        data.push({ attribute_code: key, id: parseInt(item.id), value: item.value, label: 'applyflow_custom_2' });
                    });
                }
            } else if (key === 'applyflow_custom_3') {
                if (searchFilters[key].length) {
                    searchFilters[key].forEach(function(item) {
                        data.push({ attribute_code: key, id: parseInt(item.id), value: item.value, label: 'applyflow_custom_3' });
                    });
                }
            } else if (key === 'applyflow_custom_4') {
                if (searchFilters[key].length) {
                    searchFilters[key].forEach(function(item) {
                        data.push({ attribute_code: key, id: parseInt(item.id), value: item.value, label: 'applyflow_custom_4' });
                    });
                }
            }
        });
        return data;
    },

    jobCount(state) {
        return has(state.searchPayload, 'search_results.job_count') ? state.searchPayload.search_results.job_count : 0;
    },

    companyName(state) {
        return state.brand.name || '';
    },

    companyPrimaryColor(state) {
        return has(state.brand, 'primary_color') ? state.brand.primary_color : '';
    },

    companyLogoUrl(state) {
        return has(state.brand, 'brandLogo.url') ? state.brand.brandLogo.url : '';
    },

    companySquareLogoUrl(state) {
        return has(state.brand, 'brandSquareLogo.url') ? state.brand.brandSquareLogo.url : '';
    },

    companySize(state) {
        return state.brand.company_size || '';
    },

    companyLink(state) {
        if (state.brand.slug) {
            return `/jobs/br_${state.brand.slug}`;
        }

        if (state.brand.name) {
            return `/jobs/br_${state.brand.name.replace(/ /g, '-')}`;
        }

        return '';
    },

    companyMedias(state) {
        return has(state.brand, 'medias') ? state.brand.medias : [];
    },

    companySocialMedia(state) {
        const socialMedias = [
            { name: 'facebook', url: state.brand.facebook, icon: ['fab', 'facebook-f'] },
            { name: 'linkedin', url: state.brand.linkedin, icon: ['fab', 'linkedin-in'] },
            { name: 'twitter', url: state.brand.twitter, icon: ['fab', 'x-twitter'] },
            { name: 'instagram', url: state.brand.instagram, icon: ['fab', 'instagram'] },
        ];

        return socialMedias.filter(o => o.url);
    },

    companyWebsite(state) {
        return state.brand.website || '';
    },

    companySector(state) {
        if (has(state, 'brand.attributes')) {
            const attributes = state.brand.attributes;
            const sector = attributes.find(o => o.name === 'Sector') || {};
            if (sector.id) {
                return sector.options[0].value;
            }
        }

        return '';
    },

    companyAbout(state) {
        return state.brand.brand_content || '';
    },

    companySlug(state) {
        return state.brand.slug || '';
    },
};
